import "./TermsAndConditions.css";

const PrivacyPolicy = () => {
    return (
        <section className="terms-page">
            <div className="terms-container">
                <h1 className="terms-title">Ammen Consulting SMS Privacy Policy</h1>
                <p className="terms-updated">
                <span>Last updated:</span> January 2026
                </p>
                <p>
                Ammen Consulting respects your privacy and is committed to
                safeguarding personal information collected through SMS
                communications.
                </p>

                <h2 className="terms-section-title">Information Collected</h2>
                <p className="terms-highlight">
                When participating in our SMS program, we may collect:
                </p>
                <ul className="terms-list">
                <li>Mobile phone number</li>
                <li>Message content exchanged with Ammen Consulting representatives</li>
                <li>Communication metadata (timestamps and routing information)</li>
                </ul>

                <h2 className="terms-section-title">Use of Information</h2>
                <p>Collected information is used solely to:</p>
                <ul className="terms-list">
                <li>
                    Conduct business communications related to consulting services
                </li>
                <li>Respond to inquiries and provide client support</li>
                <li>
                    Maintain records for operational, legal, or compliance purposes
                </li>
                </ul>

                <h2 className="terms-section-title">Information Sharing</h2>
                <p>
                Ammen Consulting does not sell, rent, or share SMS-related personal
                information with third parties for marketing purposes. Information may
                be shared only with service providers necessary to deliver messaging
                services or when required by law.
                </p>

                <h2 className="terms-section-title">Data Security</h2>
                <p>
                Reasonable administrative and technical safeguards are implemented to
                protect SMS-related information from unauthorized access or
                disclosure.
                </p>

                <h2 className="terms-section-title">Data Retention</h2>
                <p>
                SMS communications are retained only for as long as necessary to meet
                business, legal, or regulatory requirements.
                </p>

                <h2 className="terms-section-title">User Rights</h2>
                <p>
                Recipients may opt out of SMS communications at any time by replying{" "}
                <strong>STOP</strong>. Requests regarding personal data may be
                directed to <strong>info@ammenconsulting.com</strong>.
                </p>

                <h2 className="terms-section-title">Policy Updates</h2>
                <p>
                This Privacy Policy may be updated periodically. Revisions will be
                posted on this page with an updated effective date.
                </p>

                <h2 className="terms-section-title">Contact Information</h2>
                <p className="terms-contact-name">Ammen Consulting</p>
                <p className="terms-contact-email">
                Email: <strong>info@ammenconsulting.com</strong>
                </p>
            </div>
        </section>
    );
}

export default PrivacyPolicy;